<template>
  <div class="Toggle">
    <label
      class="Toggle-label"
      v-for="option in options"
      v-bind:key="option.value"
      @click="toggle(option)"
    >
      <input
        :checked="option === selected"
        class="Toggle-input"
        type="radio"
        :name="radioID"
        value="option"
      />
      <span
        class="Toggle-button Button">
        {{ option }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
    },
    selected: {
      type: String,
      default: ''
    }
  },
  computed: {
    radioID() {
      return Math.random().toString(36);
    }
  },
  methods: {
    toggle(newValue) {
      this.$emit('change', newValue);
    }
  }
}
</script>
